import React from 'react';
import PropTypes from 'prop-types';
import { Control } from 'react-redux-form';

import { LocalForm } from 'react-redux-form';
import { scenarios as Constant, params as paramsConstants } from './../helpers';
import DatePicker from 'react-datepicker';
import SelectComponent from './SelectComponent';
import Moment from 'moment';

import {
  FormGroup,
  Row,
  Col,
  ControlLabel,
  Glyphicon,
  Modal,
  Collapse,
  Button
} from 'react-bootstrap';

export default class ShowHistoryComponent extends React.Component {
  static propTypes = {
    visible: PropTypes.bool,
    hide: PropTypes.func,
    scenarioName: PropTypes.string,
    startDate: PropTypes.object,
    submit: PropTypes.func,
    toggleDetails:PropTypes.func,
    runsToShow: PropTypes.number,
    dispatcherJobNumber: PropTypes.number,
    runStatus: PropTypes.string,
    paramsByJobIds: PropTypes.object,
    scenariosToShow: PropTypes.array,
    details: PropTypes.bool
  };

  render() {
    const {
      visible,
      hide,
      scenarioName,
      startDate,
      submit,
      runsToShow,
      paramsByJobIds,
      scenariosToShow,
      details,
      toggleDetails
    } = this.props;

    const buildTypes = ['Production', 'Topic'];

    const initialState = {
      scenarioName: scenarioName,
      startDate,
      buildType: buildTypes[0],
      runsToShow: runsToShow
    };

    let columns = [];
    const toShow = [];
    let rowKey = 0;

    for (let i = 0; i < Math.min(runsToShow, scenariosToShow.length); i++) {
      const status = scenariosToShow[i].status;
      const runner = scenariosToShow[i].runner;
      const date = scenariosToShow[i].created_at.slice(0, 10);
      const trigger = paramsByJobIds[runner][paramsConstants.DISPATCHEDBY];
      const iefBuild = paramsByJobIds[runner][paramsConstants.JENKINS_IEF_VER];
      const processBuild = paramsByJobIds[runner][paramsConstants.PROCESS_VERSION];
      const node = paramsByJobIds[runner][paramsConstants.NODE];
      const dispatcherJobNameNumber =
         paramsByJobIds[runner][paramsConstants.JENKINS_DISPATCHER_JOB_NAME_NUMBER];
      const hyphen = dispatcherJobNameNumber.lastIndexOf('_');
      columns.push(
        <Col key={i} md={3}>
          <br />
          <span style={{ color: Constant.SCENARIO_STATE_INFO[status].colour }}>
            <br />
            <b>SelectedRun: {dispatcherJobNameNumber.slice(hyphen + 1)}</b><br />
            <Glyphicon glyph={Constant.SCENARIO_STATE_INFO[status].glyph} />
            {Constant.SCENARIO_STATE_INFO[status].label}
          </span>
          <br />
          <Collapse in={details && status !== Constant.SCENARIO_NA}>
            <span>
              Date: {date} <br />
              Dispatched By: {trigger} <br />
              IEF: {iefBuild} <br />
              Process: {processBuild} <br />
              Node: {node}
            </span>
          </Collapse>
        </Col>
      );
      if (i % 4 === 3) {
        toShow.push(
          <Row key={rowKey++}>
            {columns}
          </Row>
        );
        columns = [];
      }
    }

    toShow.push(
      <Row key={rowKey}>
        {columns}
      </Row>
    );

    return (
      <Modal show={visible} onHide={hide} bsSize="large" dialogClassName="large-modal">
        <Modal.Header closeButton>
          <Modal.Title>Artifact Health History for {scenarioName}</Modal.Title>
        </Modal.Header>
        <LocalForm
          id="show-history-form"
          onSubmit={submit}
          onChange={model => {
            this.setState(
              { ...model }
            );
            submit(model);
          }}
          initialState={initialState}
        >
          <Modal.Body>
            <FormGroup>
              <Col md={2}>
                <ControlLabel>Show Runs Since</ControlLabel>
                <Control.custom
                  id="date-picker"
                  component={DatePicker}
                  className="form-control"
                  model=".startDate"
                  mapProps={({ modelValue, onChange }) => {
                    return {
                      dateFormat: 'YYYY-MM-DD',
                      selected: Moment(modelValue),
                      onChange: d => {
                        onChange(d.toDate());
                      }
                    };
                  }}
                />
              </Col>
              <Col md={2}>
                <ControlLabel>Runs To Show</ControlLabel>
                <Control
                  id = "runs-to-show"
                  model = ".runsToShow"
                  className="form-control"
                  type="number"
                  mapProps={({ modelValue, onChange }) => {
                    return {
                      value: modelValue.runsToShow,
                      onChange: onChange
                    };
                  }}
                />
              </Col>
              <Col md={3}>
                <ControlLabel>Build Types</ControlLabel>
                <Control.custom
                  id="status-input"
                  component={SelectComponent}
                  className="form-control"
                  model=".buildType"
                  mapProps={({ modelValue, onChange }) => {
                    return {
                      options: buildTypes,
                      selected: modelValue,
                      onChange: onChange
                    };
                  }}
                />
              </Col>
            </FormGroup>
            <hr />
            <Row>
              <Col md={12}>
                {toShow}
              </Col>
            </Row>
          </Modal.Body>
        </LocalForm>
        <Col md={3}>
          <ControlLabel />
          <div>
            <Button onClick={toggleDetails}>{details ? 'Hide' : 'Show'}
              Details</Button>
          </div>
        </Col>
        <Modal.Footer>
          <Button onClick={hide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/ShowHistoryComponent.jsx